// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceRenewalDto
 */
export interface IServiceRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof IServiceRenewalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceRenewalDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IServiceRenewalDto interface.
 */
export function instanceOfIServiceRenewalDto(value: object): value is IServiceRenewalDto {
    return true;
}

export function IServiceRenewalDtoFromJSON(json: any): IServiceRenewalDto {
    return IServiceRenewalDtoFromJSONTyped(json, false);
}

export function IServiceRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IServiceRenewalDtoToJSON(json: any): IServiceRenewalDto {
    return IServiceRenewalDtoToJSONTyped(json, false);
}

export function IServiceRenewalDtoToJSONTyped(value?: IServiceRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

